import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import { editarMetodo, obtenerMetodo, limpiarMetodo } from '../../../actions/configuracion';
import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        paddingTop: '5px',
        paddingBottom: '5px',
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        overflow: "visible",
        marginTop: "10px"
    }),
    placeholder: (provided, state) => ({
        ...provided,
        position: "absolute",
        top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
        transition: "top 0.1s, font-size 0.1s",
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const tiposMetodo = [
    { value: 1, label: 'Cobrar' },
    { value: 2, label: 'Pagar' },
    { value: 3, label: 'Ambos' }
];

const EditarMetodo = ({ metodo, handleCerrar }) => {

    const dispatch = useDispatch();

    const detalles = useSelector(state => state.configuracion.metodos.detalles);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [metodoData, setMetodoData] = useState({
        id: null,
        nombre: null,
        tipo: null,
        descripcion: null
    });

    const [tipoData, setTipoData] = useState(null);

    useEffect(() => {
        if (metodo) {
            dispatch(obtenerMetodo(metodo._id));
        }
        setEditarModal(metodo ? true : false);
    }, [metodo]);

    useEffect(() => {
        if (detalles != null) {
            setMetodoData({
                id: detalles._id,
                nombre: detalles.nombre ?? null,
                tipo: detalles.tipo ?? null,
                descripcion: detalles.descripcion ?? null
            });

            if (detalles.tipo != null) {
                const tipoEncontrado = tiposMetodo.find(t => t.value === detalles.tipo);
                setTipoData(tipoEncontrado || null);
            }
        }
    }, [detalles]);

    const handleInputChange = ({ target }) => {
        setMetodoData({ ...metodoData, [target.name]: target.value });
    };

    const handleSelectTipo = (option) => {
        setTipoData(option);
        setMetodoData({ ...metodoData, tipo: option?.value ?? null });
    };

    const handleClose = () => {
        setEditarModal(false);
        dispatch(limpiarMetodo());

        setMetodoData({ id: null, nombre: null, tipo: null, descripcion: null });
        setTipoData(null);

        handleCerrar();
    };

    const handleSubmit = async () => {
        setStatusProcesar(true);
        await dispatch(editarMetodo(metodoData));
        setStatusProcesar(false);
        handleClose();
    };

    return (
        <Modal show={editarModal} backdrop="static" centered onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Editar método</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="tipo"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Tipo"
                                options={tiposMetodo}
                                value={tipoData}
                                onChange={handleSelectTipo}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nombre"
                                id="nombre"
                                name="nombre"
                                value={metodoData.nombre || ''}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="nombre">Nombre</label>
                        </div>
                    </div>
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <textarea className="form-control textareCampo" placeholder="Descripción" id="descripcion" name="descripcion" value={metodoData.descripcion || ''} onChange={handleInputChange}></textarea>
                                <label htmlFor="descripcion">Descripción</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={handleClose} disabled={statusProcesar}>
                    Cancelar
                </button>
                {
                    statusProcesar
                        ? <button className="btn btn-success" disabled><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Guardando</button>
                        : <button className="btn btn-success" onClick={handleSubmit}><i className="fas fa-check me-1"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default EditarMetodo;
